// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ticket-list-container {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);
}

.ticket-filter {
  display: flex;
  gap: var(--spacing-xs);
  padding: var(--spacing-xs);
  background: var(--color-gray-100);
  border-radius: var(--radius-md);
  border: 1px solid var(--color-gray-200);
}

.filter-btn {
  padding: var(--spacing-sm) var(--spacing-md);
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--color-gray-700);
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all var(--transition-base);
  position: relative;
}

.filter-btn:hover {
  color: var(--color-secondary);
  background: var(--color-gray-200);
}

.filter-btn.active {
  color: white;
  background: var(--color-secondary-dark);
  box-shadow: var(--shadow-sm);
}

.filter-btn.active::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  height: 2px;
  background: var(--color-primary);
  border-radius: var(--radius-full);
}

.filter-btn.active:hover {
  background: #1a3a5c;
}

.ticket-list {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
  max-height: 300px;
  overflow-y: auto;
  padding-right: var(--spacing-sm);
}

/* Custom scrollbar */
.ticket-list::-webkit-scrollbar {
  width: 6px;
}

.ticket-list::-webkit-scrollbar-track {
  background: var(--color-gray-100);
  border-radius: var(--radius-full);
}

.ticket-list::-webkit-scrollbar-thumb {
  background: var(--color-gray-300);
  border-radius: var(--radius-full);
}

.ticket-list::-webkit-scrollbar-thumb:hover {
  background: var(--color-gray-400);
}

.ticket-item {
  padding: var(--spacing-md);
  background: var(--color-gray-50);
  border-radius: var(--radius-md);
  border-left: 3px solid var(--color-gray-200);
  transition: all var(--transition-base);
  cursor: pointer;
}

.ticket-item:hover {
  background: white;
  box-shadow: var(--shadow-sm);
  transform: translateX(2px);
}

.ticket-item.high { 
  border-left-color: var(--color-danger);
  background: linear-gradient(to right, rgba(239, 68, 68, 0.05), transparent);
}
.ticket-item.medium { 
  border-left-color: var(--color-warning);
  background: linear-gradient(to right, rgba(245, 158, 11, 0.05), transparent);
}
.ticket-item.low { 
  border-left-color: var(--color-secondary-light);
}

.ticket-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
}

.ticket-id-btn {
  font-weight: 600;
  color: var(--color-secondary);
  font-size: var(--font-size-sm);
  background: transparent;
  border: none;
  padding: var(--spacing-xs) var(--spacing-sm);
  margin: calc(-1 * var(--spacing-xs)) calc(-1 * var(--spacing-sm));
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all var(--transition-base);
  position: relative;
  text-decoration: none;
}

.ticket-id-btn::after {
  content: '';
  position: absolute;
  bottom: 2px;
  left: var(--spacing-sm);
  right: var(--spacing-sm);
  height: 1px;
  background: var(--color-primary);
  transform: scaleX(0);
  transition: transform var(--transition-base);
}

.ticket-id-btn:hover {
  background: var(--color-gray-100);
  color: var(--color-primary);
}

.ticket-id-btn:hover::after {
  transform: scaleX(1);
}

.ticket-id-btn.copied {
  color: var(--color-success);
  background: rgba(16, 185, 129, 0.1);
}

.ticket-id-btn.copied::before {
  content: '✓';
  position: absolute;
  right: -16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: var(--font-size-xs);
  color: var(--color-success);
  animation: checkmark var(--transition-slow) ease-out;
}

@keyframes checkmark {
  0% {
    opacity: 0;
    transform: translateY(-50%) scale(0.5);
  }
  50% {
    transform: translateY(-50%) scale(1.2);
  }
  100% {
    opacity: 1;
    transform: translateY(-50%) scale(1);
  }
}

.ticket-id-btn:active {
  transform: scale(0.95);
}

.ticket-priority {
  font-size: var(--font-size-xs);
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: var(--radius-sm);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.priority-high { 
  background: rgba(239, 68, 68, 0.15);
  color: var(--color-danger);
  border: 1px solid rgba(239, 68, 68, 0.3);
}
.priority-medium { 
  background: rgba(245, 158, 11, 0.15);
  color: var(--color-warning);
  border: 1px solid rgba(245, 158, 11, 0.3);
}
.priority-low { 
  background: rgba(44, 82, 130, 0.15);
  color: var(--color-secondary);
  border: 1px solid rgba(44, 82, 130, 0.3);
}

.ticket-details {
  font-size: var(--font-size-sm);
  color: var(--color-gray-700);
  line-height: 1.5;
  margin-top: var(--spacing-xs);
}`, "",{"version":3,"sources":["webpack://./src/components/TicketList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,iCAAiC;EACjC,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,4CAA4C;EAC5C,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;EAC/B,4CAA4C;EAC5C,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,2EAA2E;AAC7E;AACA;EACE,uCAAuC;EACvC,4EAA4E;AAC9E;AACA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;EACZ,4CAA4C;EAC5C,iEAAiE;EACjE,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;EACX,gCAAgC;EAChC,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,oCAAoC;EACtC;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,4CAA4C;EAC5C,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,wCAAwC;AAC1C;AACA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,gBAAgB;EAChB,6BAA6B;AAC/B","sourcesContent":[".ticket-list-container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-lg);\n}\n\n.ticket-filter {\n  display: flex;\n  gap: var(--spacing-xs);\n  padding: var(--spacing-xs);\n  background: var(--color-gray-100);\n  border-radius: var(--radius-md);\n  border: 1px solid var(--color-gray-200);\n}\n\n.filter-btn {\n  padding: var(--spacing-sm) var(--spacing-md);\n  font-size: var(--font-size-sm);\n  font-weight: 600;\n  color: var(--color-gray-700);\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: all var(--transition-base);\n  position: relative;\n}\n\n.filter-btn:hover {\n  color: var(--color-secondary);\n  background: var(--color-gray-200);\n}\n\n.filter-btn.active {\n  color: white;\n  background: var(--color-secondary-dark);\n  box-shadow: var(--shadow-sm);\n}\n\n.filter-btn.active::after {\n  content: '';\n  position: absolute;\n  bottom: -4px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 60%;\n  height: 2px;\n  background: var(--color-primary);\n  border-radius: var(--radius-full);\n}\n\n.filter-btn.active:hover {\n  background: #1a3a5c;\n}\n\n.ticket-list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-md);\n  max-height: 300px;\n  overflow-y: auto;\n  padding-right: var(--spacing-sm);\n}\n\n/* Custom scrollbar */\n.ticket-list::-webkit-scrollbar {\n  width: 6px;\n}\n\n.ticket-list::-webkit-scrollbar-track {\n  background: var(--color-gray-100);\n  border-radius: var(--radius-full);\n}\n\n.ticket-list::-webkit-scrollbar-thumb {\n  background: var(--color-gray-300);\n  border-radius: var(--radius-full);\n}\n\n.ticket-list::-webkit-scrollbar-thumb:hover {\n  background: var(--color-gray-400);\n}\n\n.ticket-item {\n  padding: var(--spacing-md);\n  background: var(--color-gray-50);\n  border-radius: var(--radius-md);\n  border-left: 3px solid var(--color-gray-200);\n  transition: all var(--transition-base);\n  cursor: pointer;\n}\n\n.ticket-item:hover {\n  background: white;\n  box-shadow: var(--shadow-sm);\n  transform: translateX(2px);\n}\n\n.ticket-item.high { \n  border-left-color: var(--color-danger);\n  background: linear-gradient(to right, rgba(239, 68, 68, 0.05), transparent);\n}\n.ticket-item.medium { \n  border-left-color: var(--color-warning);\n  background: linear-gradient(to right, rgba(245, 158, 11, 0.05), transparent);\n}\n.ticket-item.low { \n  border-left-color: var(--color-secondary-light);\n}\n\n.ticket-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.25rem;\n}\n\n.ticket-id-btn {\n  font-weight: 600;\n  color: var(--color-secondary);\n  font-size: var(--font-size-sm);\n  background: transparent;\n  border: none;\n  padding: var(--spacing-xs) var(--spacing-sm);\n  margin: calc(-1 * var(--spacing-xs)) calc(-1 * var(--spacing-sm));\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: all var(--transition-base);\n  position: relative;\n  text-decoration: none;\n}\n\n.ticket-id-btn::after {\n  content: '';\n  position: absolute;\n  bottom: 2px;\n  left: var(--spacing-sm);\n  right: var(--spacing-sm);\n  height: 1px;\n  background: var(--color-primary);\n  transform: scaleX(0);\n  transition: transform var(--transition-base);\n}\n\n.ticket-id-btn:hover {\n  background: var(--color-gray-100);\n  color: var(--color-primary);\n}\n\n.ticket-id-btn:hover::after {\n  transform: scaleX(1);\n}\n\n.ticket-id-btn.copied {\n  color: var(--color-success);\n  background: rgba(16, 185, 129, 0.1);\n}\n\n.ticket-id-btn.copied::before {\n  content: '✓';\n  position: absolute;\n  right: -16px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: var(--font-size-xs);\n  color: var(--color-success);\n  animation: checkmark var(--transition-slow) ease-out;\n}\n\n@keyframes checkmark {\n  0% {\n    opacity: 0;\n    transform: translateY(-50%) scale(0.5);\n  }\n  50% {\n    transform: translateY(-50%) scale(1.2);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(-50%) scale(1);\n  }\n}\n\n.ticket-id-btn:active {\n  transform: scale(0.95);\n}\n\n.ticket-priority {\n  font-size: var(--font-size-xs);\n  padding: var(--spacing-xs) var(--spacing-sm);\n  border-radius: var(--radius-sm);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.priority-high { \n  background: rgba(239, 68, 68, 0.15);\n  color: var(--color-danger);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n}\n.priority-medium { \n  background: rgba(245, 158, 11, 0.15);\n  color: var(--color-warning);\n  border: 1px solid rgba(245, 158, 11, 0.3);\n}\n.priority-low { \n  background: rgba(44, 82, 130, 0.15);\n  color: var(--color-secondary);\n  border: 1px solid rgba(44, 82, 130, 0.3);\n}\n\n.ticket-details {\n  font-size: var(--font-size-sm);\n  color: var(--color-gray-700);\n  line-height: 1.5;\n  margin-top: var(--spacing-xs);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
